var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnStakingFarming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5556 6H7.44444C6.65 6 6 6.65 6 7.44444V17.5556C6 18.35 6.65 19 7.44444 19H17.5556C18.35 19 19 18.35 19 17.5556V7.44444C19 6.65 18.35 6 17.5556 6ZM10.3333 16.1111H8.88889V11.0556H10.3333V16.1111ZM13.2222 16.1111H11.7778V8.88889H13.2222V16.1111ZM16.1111 16.1111H14.6667V13.2222H16.1111V16.1111Z",
    fill: "#EA7E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStakingFarming);
export default __webpack_public_path__ + "static/media/icn-staking-farming.f79ea0c6524734bdb4adaf1485db4b2a.svg";
export { ForwardRef as ReactComponent };